const DETAIL_MARKERS = [
  'ServicePaperId',
  'servicePaperId',
  'AppNr',
  'appNr',
  'Apps',
  'apps',
  'Customers',
  'customers',
  'Customer',
  'customer',
];

export const getFirstServicePaperId = (value) => {
  const candidates = Array.isArray(value) ? value.flat(Infinity) : [value];
  for (const candidate of candidates) {
    if (candidate && typeof candidate === 'object') {
      const objectId = candidate.ServicePaperId
        ?? candidate.servicePaperId
        ?? candidate.FisNo
        ?? candidate.fisNo;
      if (objectId != null && String(objectId).trim()) return String(objectId).trim();
      continue;
    }
    const match = String(candidate ?? '').match(/\d{3,}/);
    if (match) return match[0];
  }
  return '';
};

export const getServicePaperIds = (value) => {
  const candidates = Array.isArray(value) ? value.flat(Infinity) : [value];
  const ids = [];

  candidates.forEach((candidate) => {
    if (candidate && typeof candidate === 'object') {
      const objectValues = [
        candidate.ServicePaperNumber,
        candidate.servicePaperNumber,
        candidate.ServicePaperId,
        candidate.servicePaperId,
        candidate.FisNo,
        candidate.fisNo,
        candidate.ServicePapers,
        candidate.servicePapers,
      ];
      objectValues.forEach(objectValue => {
        getServicePaperIds(objectValue).forEach(id => ids.push(id));
      });
      return;
    }

    String(candidate ?? '').split(',').forEach((part) => {
      const match = part.trim().match(/^(\d{3,})/);
      if (match) ids.push(match[1]);
    });
  });

  return [...new Set(ids)];
};

export const unwrapServicePaperDetailResponse = (payload) => {
  let current = payload;
  for (let depth = 0; depth < 5; depth += 1) {
    if (Array.isArray(current)) {
      current = current[0] ?? null;
      continue;
    }
    if (!current || typeof current !== 'object') return current || null;
    if (DETAIL_MARKERS.some(marker => Object.prototype.hasOwnProperty.call(current, marker))) {
      return current;
    }
    const nested = current.Data
      ?? current.data
      ?? current.Result
      ?? current.result;
    if (nested === undefined || nested === current) return current;
    current = nested;
  }
  return current || null;
};
